<template>

    <Page>

        <ImageAndText 
            src="/SuccessLeavesATrail/subscriptions.jpg"
            animation="zoom"
            flip
            floor-shadow
            border>

            <h2 class="mb-4">In-car subscriptions are not popular</h2>
            <p class="font-normal text-white/80">
                Many OEMs implement an all-or-nothing strategy, 
                missing out on the larger opportunity to generate 
                higher revenue and profits in the long term.
            </p>

        </ImageAndText>

    </Page>

</template>